export default __webpack_public_path__ + "locales/vi/Common.json?hash=a00b3fddd749a8c264e7e2402b5c0d3a";